var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { classNames } from '@shapeable/utils';
var cls = classNames('toggle-pill');
import { breakpoints, theme } from '@shapeable/theme';
import { Icon } from './icon';
import { useComponentPropsFor } from '../context/component-props-context';
export var TogglePillDefaultProps = {
  isOn: false,
  iconSize: 16,
  colors: {
    text: 'strong',
    background: 'bright',
    border: 'line-subtle',
    fill: 'strong',
    hover: {
      border: 'line-mid'
    }
  }
};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    ", ";\n    border-radius: 8px;\n    box-sizing: border-box;\n    padding: ", " ", " ", " ", ";\n    display: flex;\n    flex-direction: row;\n    height: 36px;\n    white-space: nowrap; \n    box-sizing: border-box;\n    align-items: center;\n    border: 1px solid ", ";\n    font-size: ", ";\n    gap: ", ";\n    cursor: pointer;\n\n    \n    ", "\n  "], ["\n    ", ";\n    border-radius: 8px;\n    box-sizing: border-box;\n    padding: ", " ", " ", " ", ";\n    display: flex;\n    flex-direction: row;\n    height: 36px;\n    white-space: nowrap; \n    box-sizing: border-box;\n    align-items: center;\n    border: 1px solid ", ";\n    font-size: ", ";\n    gap: ", ";\n    cursor: pointer;\n\n    \n    ", "\n  "])), theme.APPLY_COLORS, theme.UNIT(1), theme.UNIT(3), theme.UNIT(1), theme.UNIT(2), theme.COLOR('line-subtle'), theme.FONT_SIZE(12), theme.UNIT(2), function (_a) {
    var isOn = _a.isOn;
    return isOn && css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      border-color: ", ";\n      background: ", ";\n      color: ", ";\n      ", ";\n    "], ["\n      border-color: ", ";\n      background: ", ";\n      color: ", ";\n      ", ";\n    "])), theme.COLOR('strong'), theme.COLOR('strong'), theme.COLOR('bright'), theme.FILL('bright'));
  })
});
var IconStyles = breakpoints({
  base: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n\n  "], ["\n\n  "])))
});
// -------- Components -------->
var My = {
  Container: styled.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Icon: styled(Icon)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["", ""], ["", ""])), IconStyles)
};
export var TogglePill = function (props) {
  var _a = useComponentPropsFor('TogglePill', TogglePillDefaultProps, props),
    className = _a.className,
    children = _a.children,
    onClick = _a.onClick,
    isOn = _a.isOn,
    label = _a.label,
    colors = _a.colors;
  var Icon = props.iconComponent;
  return React.createElement(My.Container, {
    onClick: onClick,
    isOn: isOn,
    colors: colors,
    className: cls.name(className)
  }, Icon && React.createElement(My.Icon, {
    size: 16
  }, React.createElement(Icon, null)), label || children);
};
TogglePill.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;
// TogglePill.defaultProps = TogglePillDefaultProps;